'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { isEditableTarget } from '@/lib/is-editable-target';
import { isOnSysRoute } from '@/lib/is-on-sys-route';

interface IUseKeybindingsArgs {
  isOpen: boolean;
  openPalette: () => void;
}

function shouldOpenFromSlash(e: KeyboardEvent, isOpen: boolean): boolean {
  return e.key === '/' && !isEditableTarget(e.target) && !isOpen;
}

function shouldOpenFromCmdK(e: KeyboardEvent): boolean {
  return (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k';
}

export function useKeybindings({ isOpen, openPalette }: IUseKeybindingsArgs): void {
  const pathname = usePathname();

  useEffect(() => {
    function onKeyDown(e: KeyboardEvent): void {
      if (isOnSysRoute(pathname)) {
        return;
      }
      if (shouldOpenFromSlash(e, isOpen) || shouldOpenFromCmdK(e)) {
        e.preventDefault();
        openPalette();
      }
    }
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, openPalette, pathname]);
}
